import React from "react";
import "./OpalStatsSection.css";
import TauriImage from "../TauriImage/TauriImage";

const OpalStatsSection = ({ sections }) => {
  return (
    <div className="opal-stats-section">
      {sections.map((section, sIndex) => (
        <div key={sIndex} className="mb-3">
          {/* Section Header */}
          <div className="header-section d-flex align-items-end justify-content-between mb-1">
            <span className="stats-title">{section.name}</span>
            {section.icon && (
              <TauriImage localImage={section.icon} alt="icon" color={"#1D5D9B"} />
            )}
          </div>

          <div className="stats-hr mb-2" />

          {/* Section Details */}
          {section.details && section.details.length > 0 ? (
            section.details.map((detail, iIndex) => (
              <div
                key={iIndex}
                className="d-flex align-items-center justify-content-between mb-2"
              >
                <span className="stats-subtitle">{detail.name}</span>
                <div>
                  {detail.highlight && (
                    <span className="highlighted-value me-1">{detail.highlight}</span>
                  )}
                  <span className="display-value">{detail.count}</span>
                </div>
              </div>
            ))
          ) : (
            <div className="no-details-text">No data available</div> // fallback text
          )}
        </div>
      ))
      }
    </div >
  );
};

export default OpalStatsSection;
